let hostName = document.location.hostname;
if (document.location.port != '') {
    hostName = `${document.location.hostname}:${document.location.port}`;
}

const origin = `${document.location.protocol}//${hostName}`;
export { origin };
